import React, { useState, useEffect, useCallback } from 'react';
import { investigationService } from '../services/api';
import '../styles/NotesPanel.css';

export default function NotesPanel({ investigationId }) {
  const [notes, setNotes]               = useState([]);
  const [loading, setLoading]           = useState(true);
  const [newNote, setNewNote]           = useState('');
  const [selectedAddress, setSelectedAddress] = useState('');
  const [submitting, setSubmitting]     = useState(false);

  const loadNotes = useCallback(async () => {
    try {
      setLoading(true);
      const response = await investigationService.getNotes(investigationId);
      setNotes(response.data);
    } catch (error) {
      console.error('Failed to load notes:', error);
    } finally {
      setLoading(false);
    }
  }, [investigationId]);

  useEffect(() => {
    loadNotes();
  }, [loadNotes]);

  const handleAddNote = async (e) => {
    e.preventDefault();
    if (!newNote.trim()) return;
    try {
      setSubmitting(true);
      await investigationService.addNote(investigationId, newNote, selectedAddress || null);
      setNewNote('');
      setSelectedAddress('');
      loadNotes();
    } catch (error) {
      console.error('Failed to add note:', error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleDeleteNote = async (noteId) => {
    try {
      await investigationService.deleteNote(investigationId, noteId);
      loadNotes();
    } catch (error) {
      console.error('Failed to delete note:', error);
    }
  };

  return (
    <div className="notes-panel">
      <h3>📝 Investigation Notes</h3>

      <form onSubmit={handleAddNote} className="note-form">
        <textarea
          value={newNote}
          onChange={(e) => setNewNote(e.target.value)}
          placeholder="Add an investigation note..."
          className="note-input"
        />
        <div className="form-controls">
          <input
            type="text"
            value={selectedAddress}
            onChange={(e) => setSelectedAddress(e.target.value)}
            placeholder="Address (optional)"
            className="address-input"
          />
          <button
            type="submit"
            disabled={submitting || !newNote.trim()}
            className="btn-submit"
          >
            {submitting ? 'Adding...' : 'Add Note'}
          </button>
        </div>
      </form>

      {loading ? (
        <p>Loading notes...</p>
      ) : notes.length === 0 ? (
        <p className="empty">No notes yet. Add one to get started!</p>
      ) : (
        <div className="notes-list">
          {notes.map((note) => (
            <div key={note.id} className="note-item">
              <div className="note-header">
                <strong>{note.author}</strong>
                <span className="note-date">
                  {new Date(note.created_at).toLocaleDateString()}
                </span>
              </div>
              {note.address && (
                <code className="note-address">{note.address}</code>
              )}
              <p className="note-content">{note.content}</p>
              <button onClick={() => handleDeleteNote(note.id)} className="btn-delete">
                Delete
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
